import { createSlice } from "@reduxjs/toolkit";
import { getAllNews, getNewsDetails ,getNewsCategories } from "../actions/news.actions";

const initialState = {
  news: {
    loading: false,
    error: null as unknown | null,
    data: [] as any,
  },

  newsDetails: [] as any,
  newsCategories : [] as any,
  loading: false,
  error: null as unknown | null,
};
export const newsSlice = createSlice({
  name: "news",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllNews.pending, (state) => {
        state.news.loading = true;
      })
      .addCase(getAllNews.fulfilled, (state, action) => {
        state.news.data = action.payload;
        state.news.loading = false;
      })
      .addCase(getAllNews.rejected, (state, action) => {
        state.news.data = [];
        state.news.loading = false;
        state.error = action.payload;
      })
      
      // getNewsDetails cases
      .addCase(getNewsDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNewsDetails.fulfilled, (state, action) => {
        state.newsDetails = action.payload;
        state.loading = false;
      })
      .addCase(getNewsDetails.rejected, (state, action) => {
        state.newsDetails = null;
        state.loading = false;
        state.error = action.error.message;
      })
      //get news categories 
      .addCase(getNewsCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNewsCategories.fulfilled, (state, action) => {
        state.newsCategories = action.payload;
        state.loading = false;
      })
      .addCase(getNewsCategories.rejected, (state, action) => {
        state.newsCategories = null;
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default newsSlice.reducer;
